import Vue from 'vue'
import Vuex from 'vuex'
import Element from '../components/Element.vue';
import axios from "axios";
import VueCookies from 'vue-cookies'
import Storage from 'vue-ls';
import Notifications from 'vue-notification'
import Router from "../components/Router.vue";

Vue.config.productionTip = false

Vue.use(Vuex);
Vue.use(VueCookies);
Vue.use(Storage, {
    namespace: 'igr_',
    name: 'ls',
    storage: 'local',
});
Vue.use(Notifications);

const router = Router;

const store = new Vuex.Store({
    state: {
        page: {
        },
        settings: {
            url: '',
            id: 0,
            name: '',
        }
    },
    mutations: {
        updatePage(state, page) {
            state.page = page;
        },
        setSettings(state, settings) {
            state.settings = settings;
        },
    },
    actions: {
        UPDATE_STORE: (context, payload) => {
            axios.post(
                '/ajax/getPage.php',
                {
                    'route': context.state.settings.route,
                },
                {
                    headers: {
                        'content-type': 'application/json; charset=utf8'
                    }
                }
            )
                .then(function (response) {
                    context.commit("updatePage", response.data);

                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        SET_SETTINGS: (context, payload) => {
            payload = {
                id: payload.id ? parseInt(payload.id) : context.state.settings.id,
                route: payload.route ? payload.route : context.state.settings.route,
            };
            context.commit("setSettings", payload)
        }
    },
    getters: {
        page: state => state.page,
        settings: state => state.settings
    }
})

new Vue({
    router,
    store,
    render: function (h) {
        return h(Element);
    },
    el: '#app',
    data: {
    },
    components: {
        Element
    },
    created() {
        this.$cookies.config('30d');

        const regex = /\/catalog\/(?<catalogId>[0-9]+)\/(?<goodId>[0-9]+)\//;
        let m;
        let goodId = 0;
        if ((m = regex.exec(this.$route.path)) !== null) {
            goodId = m.groups.goodId > 0 ? m.groups.goodId : 0;
            this.$store.dispatch('SET_SETTINGS', {id: goodId});
        }

        this.$store.dispatch('SET_SETTINGS', {route: {
                path: this.$route.path,
                query: this.$route.query,
            }});

        this.$store.dispatch('UPDATE_STORE', true);
    },
});